import Turbolinks from 'turbolinks';

// prevent page reloads when clicking links with '#' href Turbolinks issue: https://github.com/turbolinks/turbolinks/issues/75
const isVisitable = Turbolinks.Controller.prototype.nodeIsVisitable;

Turbolinks.Controller.prototype.nodeIsVisitable = (elem) => {
  const href = elem.getAttribute('href') || '';
  const isAnchor = href === "#";
  return !isAnchor && isVisitable(elem);
};
